import { DataBean } from "../DataBean";

export class ProjectProductCrud extends DataBean {


    public async getProjectProductCatalog(idProject: any, page: any, recordsPerPage: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.advantage.shared.Report_getProjectProductCatalog_Number_Number_Number", [idProject, page, recordsPerPage]);
    }

    public async deleteProjectProduct(idProjectProduct: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "void_deleteProjectProduct_Number", [idProjectProduct]);
    }
    public async exportProjectProduct(idProject: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_exportProjectProduct_Number", [idProject]);
    }
    public async updateProjectProduct(bean): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.quickdataerp.bean.projects.ProjectProduct_updateProjectProduct_com.quickdataerp.bean.projects.ProjectProduct", [
            {
                "DataBeanProperties": bean,
                "DataBeanName": "com.quickdataerp.bean.projects.ProjectProduct"
            }
        ]);
    }
}